<mat-dialog-content class="mat-typography" [innerHtml]="pdf">
</mat-dialog-content>
<mat-dialog-actions align="end">
  <a [href]="invoicePDFUrl" class="btn btn-primary" *ngIf="invoicePDFUrl != ''"
    >Download PDF</a
  >
  &nbsp;&nbsp;&nbsp;
  <button class="btn btn-danger" mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
